import React from 'react';
const convertPropsToObject = (item) => {
    const props = item.properties.reduce((merged, current) => {
        var _a, _b;
        if ((current === null || current === void 0 ? void 0 : current.valueType) === 'SCALAR') {
            merged[current.name] = {
                type: current.type,
                value: (_a = current === null || current === void 0 ? void 0 : current.value) === null || _a === void 0 ? void 0 : _a.value,
                __typename: (_b = current === null || current === void 0 ? void 0 : current.value) === null || _b === void 0 ? void 0 : _b.__typename
            };
        }
        else {
            merged[current.name] = {
                type: current.type,
                value: current.value
            };
        }
        return merged;
    }, {});
    return props;
};
const renderContent = ({ items, components }) => items.map((item, index) => {
    const Component = components[item.type.toUpperCase()] || components[item.type];
    const props = convertPropsToObject(item);
    if (Component) {
        return (React.createElement(Component, Object.assign({ key: `${item.type}-${index}` }, props), (item === null || item === void 0 ? void 0 : item.children) && item.children.length > 0
            ? renderContent({ items: item.children, components })
            : null));
    }
    else
        return null;
});
export function ContentRenderer({ items, components }) {
    return React.createElement(React.Fragment, null, renderContent({ items, components }));
}
//# sourceMappingURL=ContentRenderer.js.map